import { Operation, OperationIds } from './types';

export const OPERATIONS = [
	{ order: 0, id: OperationIds.Matches, name: Operation.Matches },
	{ order: 1, id: OperationIds.Equals, name: Operation.Equals },
	{ order: 2, id: OperationIds.Contains, name: Operation.Contains },
	{ order: 3, id: OperationIds.StartsWith, name: Operation.StartsWith },
	{ order: 4, id: OperationIds.EndsWith, name: Operation.EndsWith },
	{ order: 5, id: OperationIds.ContainsKey, name: Operation.ContainsKey },
	{ order: 6, id: OperationIds.ContainsValue, name: Operation.ContainsValue },
	{ order: 7, id: OperationIds.GreaterThan, name: Operation.GreaterThan },
	{ order: 8, id: OperationIds.LessThan, name: Operation.LessThan },
	{ order: 9, id: OperationIds.IsEmpty, name: Operation.IsEmpty },
	{
		order: 10,
		id: OperationIds.EqualsIgnoreWhitespace,
		name: Operation.EqualsIgnoreWhitespace,
	},
] as const;
